<!-- @format -->

<template>
    <div></div>
</template>

<script>
import Vue from 'vue';
import isEmpty from 'lodash/isEmpty';
import { mapActions } from 'vuex';
import apiConstants from '@core/utils/constants/api';
import zIndex from '@core/scss/mixins/_z-index-export-js.scss';
import WarnBeforeLeave from '@tenant/app/mixins/WarnBeforeLeave';
import EventReservationMixin from '@tenant/app/mixins/EventReservationMixin';

export default {
    name: 'EventReservation',
    mixins: [WarnBeforeLeave, EventReservationMixin],
    props: {
        payload: {
            type: Object,
            default: () => {
                return {};
            },
        },
        callbackAddItemToCartErrorFn: {
            type: Function,
            default: () => () => {},
        },
    },
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'views.eventV2.theEvent._components.progressCircularAnimationModal',
    },
    data() {
        return {
            busEventProgressCircular: new Vue(),
            previousRoute: null,
        };
    },
    computed: {
        routeRedirectOnError() {
            return this.$route.meta.routeRedirectOnError;
        },
    },
    methods: {
        ...mapActions({
            addItemToCart: 'cart/addItem',
            instantDeleteCurrentCart: 'cart/instantDeleteCurrentCart',
        }),
        showProgressAnimationModal(payload) {
            let response;

            this.$modal.show(
                import('@tenant/app/components/modals/ProgressCircularAnimationModal.vue'),
                {
                    title: this.$t('hotelOnly.title'),
                    busEvent: this.busEventProgressCircular,
                    variant: 1,
                },
                {
                    style: `z-index: ${zIndex.highest}`,
                    'no-click-animation': true,
                    persistent: true,
                    scrollable: false,
                    fullscreen: false,
                    'hide-overlay': false,
                    'max-width': 600,
                },
                {
                    open: async () => {
                        response = await this.addItemToCart(payload);

                        if (response.success) {
                            if (this._destroyed) {
                                this.instantDeleteCurrentCart();
                            }
                            this.busEventProgressCircular.$emit('end');
                        } else {
                            this.busEventProgressCircular.$emit('close');
                        }
                    },
                    beforeClose: () => {
                        if (response?.success) {
                            //response is optional. User can close the reservation route
                            if (this._destroyed) {
                                this.instantDeleteCurrentCart();
                            } else {
                                this.$router.replace({
                                    name: 'cartCheckout',
                                    params: { cartId: response.cartId },
                                });
                            }
                        } else {
                            if (
                                response?.code ===
                                apiConstants.ERROR_CODES.HOTEL_PROVIDER.ROOM_RATE_CHANGED
                            ) {
                                this.openHotelRoomRateChangedModal(response);
                            } else {
                                this.navigateBack();
                                response && this.callbackAddItemToCartErrorFn(response);
                            }
                        }
                    },
                }
            );
        },
    },
    created() {
        if (!isEmpty(this.payload)) {
            this.showProgressAnimationModal(this.payload);
        } else {
            this.$router.replace({
                name: this.routeRedirectOnError,
                params: { id: this.$route.params.id },
            });
        }
    },
    beforeRouteEnter(to, from, next) {
        next((cmp) => {
            cmp.previousRoute = from;
        });
    },
    destroyed() {
        this._destroyed = true;
    },
};
</script>
